<div class="vormen" aria-hidden="true">
    <div class="vorm v-rood"></div>
    <div class="vorm v-geel"></div>
    <div class="vorm v-blauw"></div>
    <div class="vorm v-roze"></div>
    <div class="vorm v-kobalt"></div>
</div>
